import { Box, styled } from '@mui/material';

/** Keeps the section rows spaced the same way they were before the tab panel wrapped them. */
export const SectionTabPanel = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));
